export default {
    namespaced: true,

    state: {
        shortcuts: [],
    },

    getters: {
        getList(state) {
            return state.shortcuts
        },
    },

    mutations: {
        addOne(state, shortcut) {
            state.shortcuts.push(shortcut)
        },

        clearList(state) {
            state.shortcuts = []
        },
    },

    actions: {
        addOne(Store, shortcut) {
            Store.commit('addOne', shortcut)
        },

        clearList(Store) {
            Store.commit('clearList')
        },
    },
}
